<template>
  <div id="">
    <div class="top">
      <div class="left">
        <img
          :src="require('@/assets/image/question-back.png')"
          style="width: 40px; height: 40px; margin-right: 20px;cursor:pointer;"
          @click="clickBackList"
        />
        <img
          :src="require('@/assets/image/person.png')"
          style="width: 72px; height: 72px;margin-right: 16px;"
        />
        <div>
          <div class="name-box">
            <div class="name">{{ detailHandleList.username }}</div>
            <div class="phone">{{ detailHandleList.phone }}</div>
          </div>
          <div class="time-box" v-if="curItem.extendCardCount == '2'">
            时长：{{ detailHandleList.computeHour }}h
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-item">
        <div class="title">
          {{
            curItem.extendCardCount == "2" ? "开始值班值守信息" : "值班值守信息"
          }}
        </div>
        <div class="map-content">
          <MapCom :pointInfo="startDetailInfo" :vid="'vid1'"></MapCom>
        </div>
        <div class="info-box">
          <div class="info-box-item">
            <img src="@/assets/image/dianwei.svg" alt="" />
            <span>{{
              detailHandleList.startDetailInfo &&
                detailHandleList.startDetailInfo.logAddress
            }}</span>
          </div>
        </div>
        <div class="info-box">
          <div class="info-box-item">
            <span style="color: #92979c">{{
              curItem.extendCardCount == "2" ? "开始时间" : "打卡时间"
            }}</span>
            <span style="color: #494C4F;">{{
              detailHandleList.startDetailInfo &&
                detailHandleList.startDetailInfo.logTime
            }}</span>
          </div>
        </div>
        <div class="info-box">
          <div class="info-box-item">
            <span style="color: #92979c">值班值守说明</span>
            <span style="color: #494C4F;">{{
              detailHandleList.startDetailInfo &&
                detailHandleList.startDetailInfo.remark
            }}</span>
          </div>
        </div>
        <div class="info-box" v-if="detailHandleList.startDetailInfo &&
                detailHandleList.startDetailInfo.sourceMangerId == 'ZHIBAN'">
          <div class="info-box-item">
            <span style="color: #92979c">设备是否正常</span>
            <span style="color: #494C4F;">{{
              detailHandleList.startDetailInfo &&
                detailHandleList.startDetailInfo.deviceNormalFlag
            }}</span>
          </div>
        </div>
        <div class="title" style="margin-top: 28px;">现场照片</div>
        <div
          class="keyPic"
          v-if="
            detailHandleList.startDetailInfo &&
              detailHandleList.startDetailInfo.fileJson
          "
        >
          <el-image
            class="imgPic"
            v-for="(itempic, index) in JSON.parse(
              detailHandleList.startDetailInfo.fileJson
            )"
            :key="index"
            :src="itempic.url"
            :preview-src-list="
              JSON.parse(detailHandleList.startDetailInfo.fileJson).map(
                item => item.url
              )
            "
          >
          </el-image>
        </div>
      </div>
      <div class="bottom-item" v-if="curItem.extendCardCount == '2'">
        <div class="title">结束值班值守信息</div>
        <div class="map-content">
          <MapCom :pointInfo="endDetailInfo" :vid="'vid2'"></MapCom>
        </div>
        <div class="info-box">
          <div class="info-box-item">
            <img src="@/assets/image/dianwei.svg" alt="" />
            <span>{{
              detailHandleList.endDetailInfo &&
                detailHandleList.endDetailInfo.logAddress
            }}</span>
          </div>
        </div>
        <div class="info-box">
          <div class="info-box-item">
            <span style="color: #92979c">结束时间</span>
            <span style="color: #494C4F;">{{
              detailHandleList.endDetailInfo &&
                detailHandleList.endDetailInfo.logTime
            }}</span>
          </div>
        </div>
        <div class="info-box">
          <div class="info-box-item">
            <span style="color: #92979c">值班值守说明</span>
            <span style="color: #494C4F;">{{
              detailHandleList.endDetailInfo &&
                detailHandleList.endDetailInfo.remark
            }}</span>
          </div>
        </div>
        <div class="info-box" v-if="detailHandleList.endDetailInfo &&
                detailHandleList.endDetailInfo.sourceMangerId == 'ZHIBAN'">
          <div class="info-box-item">
            <span style="color: #92979c">设备是否正常</span>
            <span style="color: #494C4F;">{{
              detailHandleList.endDetailInfo &&
                detailHandleList.endDetailInfo.deviceNormalFlag
            }}</span>
          </div>
        </div>
        <div class="title" style="margin-top: 28px;">现场照片</div>

        <div
          class="keyPic"
          v-if="
            detailHandleList.endDetailInfo &&
              detailHandleList.endDetailInfo.fileJson
          "
        >
          <el-image
            class="imgPic"
            v-for="(itempic, index) in JSON.parse(
              detailHandleList.endDetailInfo.fileJson
            )"
            :key="index"
            :src="itempic.url"
            :preview-src-list="
              JSON.parse(detailHandleList.endDetailInfo.fileJson).map(
                item => item.url
              )
            "
          >
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapCom from "@/pages/reportproblemAnalysis/components/map.vue";
import { fillDutyLogDetail } from "@/api/onDutyAndStandBy.js";

export default {
  name: "",
  components: {
    MapCom
  },
  props: {
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      detailHandleList: {},
      startDetailInfo: {
        reportAddressLong: "",
        reportAddressLat: ""
      },
      endDetailInfo: {
        reportAddressLong: "",
        reportAddressLat: ""
      }
    };
  },
  mounted() {
    this.fillDutyLogDetailFun();
  },
  methods: {
    clickBackList() {
      console.log(111111);

      this.$emit("clickBackList");
    },
    // 详情
    async fillDutyLogDetailFun() {
      let params = {
        id: this.curItem.id
      };
      const res = await fillDutyLogDetail(params);
      if (res.data.code == 200) {
        this.detailHandleList = res.data.data;
        if (
          this.detailHandleList.startDetailInfo &&
          this.detailHandleList.startDetailInfo.longAndLatStart
        ) {
          this.startDetailInfo.reportAddressLong = this.detailHandleList.startDetailInfo.longAndLatStart.split(
            ","
          )[0];
          this.startDetailInfo.reportAddressLat = this.detailHandleList.startDetailInfo.longAndLatStart.split(
            ","
          )[1];
        }
        if (
          this.detailHandleList.endDetailInfo &&
          this.detailHandleList.endDetailInfo.longAndLatStart
        ) {
          this.endDetailInfo.reportAddressLong = this.detailHandleList.endDetailInfo.longAndLatStart.split(
            ","
          )[0];
          this.endDetailInfo.reportAddressLat = this.detailHandleList.endDetailInfo.longAndLatStart.split(
            ","
          )[1];
        }

        console.log(this.detailHandleList, "this.detailHandleList");
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
.top {
  width: 100%;
  height: 128px;
  margin-top: 12px;
  margin-bottom: 20px;
  background: linear-gradient(
      180deg,
      rgba(0, 157, 255, 0.09) 0%,
      rgba(244, 252, 255, 0) 100%
    ),
    #ffffff;
  border-radius: 8px;
  padding: 28px 32px;
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
    .name-box {
      display: flex;
      align-items: baseline;
      .name {
        font-weight: 600;
        font-size: 24px;
        color: #494c4f;
        margin-right: 12px;
      }
      .phone {
        font-size: 16px;
        color: #494c4f;
      }
    }
    .time-box {
      font-size: 16px;
      color: #92979c;
      margin-top: 8px;
    }
  }
}
.bottom {
  display: flex;
  background: #fff;
  .bottom-item {
    flex: 1;
    padding: 28px 32px;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #494c4f;
      margin-bottom: 12px;
    }
    .map-content {
      width: 100%;
      height: 288px;
    }
    .info-box {
      margin-top: 12px;
      display: flex;
      align-items: center;
      margin-top: 16px;
      .info-box-item {
        display: flex;
        align-items: center;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #92979c;
        margin-right: 54px;

        img,
        span {
          margin-right: 8px;
        }

        img {
          height: 15px;
        }
      }

      .info-box-item:last-child {
        margin-right: 0;
      }
    }
  }
  .bottom-item:first-child {
    margin-right: 16px;
  }
}
.keyPic {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  /deep/ .el-image {
    margin: 0 !important;
  }

  .imgPic {
    width: 172px;
    height: 120px;
    margin-right: 12px !important;
    margin-bottom: 12px !important;
    border-radius: 4px;
    // margin-right: 12px;
    // margin-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/onDuty/detail.vue